import React, { useState, useCallback, useEffect, useRef } from 'react';
import { DebounceInput } from 'react-debounce-input';
import { useDispatch } from 'react-redux';
import onClickOutside from 'react-onclickoutside';
import classNames from 'classnames';

import {
    getPlayers
} from './../../../actions/leader-board';
import styles from '../../../components/dropdown/dropdown.module.css';
import {detectIconById} from "../../../common/enum";

function PlayerSearch(props) {
    const { selected, fullWidth, disabled, teamIds } = props;

    const [selectedPlayer, setSelectedPlayer] = useState({
        playerName: '',
        id: null
    });
    const [suggestions, setSuggestions] = useState([]);
    const [toggle, setToggle] = useState(false);
    const dispatch = useDispatch();

    const wrapperRef = useRef(null);

    useEffect(() => {
        if (!selected) return;
        setSelectedPlayer(selected);
    }, [selected]);

    useEffect(() => {
        document.addEventListener("click", handleClickOutside, false);
        return () => {
            document.removeEventListener("click", handleClickOutside, false);
        };
    }, []);

    const handleClickOutside = useCallback((event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setToggle(false);
        }
    }, []);

    const onSearch = useCallback(async (value) => {
        try {
            const result = await dispatch(getPlayers({
                keyword: value,
                teamIds,
            }));
            setToggle(true);
            setSuggestions(result);
        } catch (e) {
            setSuggestions([]);
            setToggle(true);
        }
    }, [props]);

    const onSelectPlayer = useCallback((player) => {
        setSelectedPlayer({
            playerName: player.player_name,
            id: player.id
        });
        setToggle(false);
        props.onChoosePlayer(player);
    }, []);

    PlayerSearch.handleClickOutside = useCallback(() => {
        setToggle(false);
    }, []);

    return <div style={{ position: 'relative' }} ref={wrapperRef}>
        <div className="option-bottom" style={{ alignItems: 'flex-start' }}>
            <DebounceInput
                style={{
                    border: '1px solid #D1D9DE',
                    borderRadius: 4,
                    padding: '10px 12px',
                    fontSize: 14,
                    outline: 'none',
                    width: fullWidth ? '100%' : '140px',
                }}
                disabled={disabled}
                value={selectedPlayer.playerName}
                onFocus={(e) => {
                    if (!e.target.value) return;
                    setToggle(true);
                }}
                placeholder={props.placeholder}
                debounceTimeout={300}
                onChange={e => {
                    setSelectedPlayer({
                        playerName: e.target.value,
                        id: null,
                    });
                    if (!e.target.value) return;
                    onSearch(e.target.value);
                }} />
        </div>
        <div className={classNames(styles.dropdownMenu, toggle && styles.displayBlock)} style={{ minWidth: 150 }}>
            {suggestions.map((suggestion, index) => {
                return <div onClick={() => onSelectPlayer(suggestion)} className={styles.dropdownMenuItem} key={index}>
                    <div>
                        <img style={{width: 20, marginRight: 10}}
                             src={detectIconById(suggestion.team.id)} alt="team-name"/>
                        {suggestion.player_name}
                        <span style={{
                            color: '#74818A',
                            fontSize: 13,
                            marginLeft: 10
                        }}>{suggestion.uniform_number}</span>
                    </div>
                    <span className="fa fa-search form-control-feedback" />
                </div>
            })}
        </div>
    </div>
}

PlayerSearch.defaultProps = {
    fullWidth: false,
}


export default PlayerSearch;
